export { default } from 'ember-cli-mirage/instance-initializers/ember-cli-mirage-autostart';
